import styled from 'styled-components';

export const Container = styled.section`
  margin-top: 12rem;
  display: flex;
  gap: 4rem;
  flex-direction: row;
  align-items: flex-start;
  position: relative;
  overflow: hidden;
  
  /* Animated background particles */
  &::before {
    content: '';
    position: absolute;
    top: -100px;
    right: -100px;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle, rgba(139, 92, 246, 0.1) 0%, transparent 70%);
    border-radius: 50%;
    animation: pulse 8s ease-in-out infinite;
    z-index: -1;
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: -150px;
    left: -150px;
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, rgba(99, 102, 241, 0.08) 0%, transparent 70%);
    border-radius: 50%;
    animation: pulse 10s ease-in-out infinite reverse;
    z-index: -1;
  }
  
  @keyframes pulse {
    0%, 100% { transform: scale(1); opacity: 0.5; }
    50% { transform: scale(1.2); opacity: 0.8; }
  }

  .about-text {
    flex: 1;
    position: relative;
    z-index: 1;
  }

  .hard-skills{
    margin-top: 3rem;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
    gap: 2rem;
  }
  
  .hability{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    background: linear-gradient(135deg, 
      rgba(30, 41, 59, 0.6) 0%, 
      rgba(15, 23, 42, 0.8) 100%);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(99, 102, 241, 0.2);
    border-radius: 1.8rem;
    transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    
    /* Gradient top border */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, 
        #6366f1 0%, 
        #8b5cf6 50%, 
        #06b6d4 100%);
      opacity: 0;
      transition: opacity 0.5s ease;
    }
    
    /* Shine effect */
    &::after {
      content: '';
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: linear-gradient(
        45deg,
        transparent 30%,
        rgba(255, 255, 255, 0.1) 50%,
        transparent 70%
      );
      transform: translateX(-100%) translateY(-100%) rotate(45deg);
      transition: transform 0.6s ease;
    }

    &:hover {
      transform: translateY(-12px) scale(1.08) rotateY(5deg);
      border-color: var(--primary);
      box-shadow: 0 20px 40px rgba(99, 102, 241, 0.4),
                  0 0 30px rgba(139, 92, 246, 0.3),
                  inset 0 1px 0 rgba(255, 255, 255, 0.1);
      background: linear-gradient(135deg, 
        rgba(99, 102, 241, 0.2) 0%, 
        rgba(139, 92, 246, 0.15) 100%);
      
      &::before {
        opacity: 1;
      }
      
      &::after {
        transform: translateX(100%) translateY(100%) rotate(45deg);
      }
      
      img {
        transform: scale(1.15) rotateZ(5deg);
        filter: drop-shadow(0 8px 16px rgba(99, 102, 241, 0.5)) brightness(1.2);
      }
    }

    img{
      width: 4.5rem;
      height: 4.5rem;
      object-fit: contain;
      filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.4));
      transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
      position: relative;
      z-index: 1;
    }
  }

  h2{
    display: inline-block;
    margin-bottom: 3.5rem;
    font-size: clamp(3.5rem, 5vw, 5rem);
    font-weight: 900;
    background: linear-gradient(135deg, 
      #6366f1 0%, 
      #8b5cf6 50%, 
      #06b6d4 100%);
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: shimmerText 3s linear infinite;
    position: relative;
    letter-spacing: -0.02em;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -1.5rem;
      left: 0;
      width: 0;
      height: 4px;
      background: linear-gradient(90deg, #6366f1, #8b5cf6, #06b6d4);
      border-radius: 4px;
      animation: expandUnderline 1.5s ease-out forwards;
      box-shadow: 0 2px 10px rgba(99, 102, 241, 0.5);
    }
  }
  
  @keyframes shimmerText {
    0% { background-position: 0% center; }
    100% { background-position: 200% center; }
  }
  
  @keyframes expandUnderline {
    0% { width: 0; }
    100% { width: 100px; }
  }

  h3{
    margin-top: 3.5rem;
    margin-bottom: 2rem;
    font-size: clamp(2.2rem, 3.5vw, 2.8rem);
    font-weight: 700;
    background: linear-gradient(90deg, 
      #3b82f6 0%,
      #8b5cf6 50%,
      #06b6d4 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: relative;
    letter-spacing: -0.01em;
    
    &::before {
      content: '⚡';
      position: absolute;
      left: -3rem;
      animation: pulse 2s ease-in-out infinite;
    }
  }

  p{
    font-size: clamp(1.6rem, 2vw, 1.9rem);
    letter-spacing: 0.03rem;
    font-weight: 400;
    line-height: 2;
    color: rgba(255, 255, 255, 0.9);
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  .about-image{
    text-align: center;
    flex: 1;
    position: relative;
    perspective: 1200px;
    
   img{
     margin-top: 2rem;
     width: 50%;
     border-radius: 24px;
     filter: grayscale(0);
     transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
     box-shadow: 0 25px 70px rgba(99, 102, 241, 0.35),
                 0 10px 25px rgba(0, 0, 0, 0.3);
     border: 3px solid rgba(99, 102, 241, 0.3);
     position: relative;
     
     /* Animated gradient glow */
     &::before {
       content: '';
       position: absolute;
       inset: -4px;
       border-radius: 24px;
       background: linear-gradient(45deg, 
         #6366f1, #8b5cf6, #06b6d4, #8b5cf6, #6366f1);
       background-size: 400% 400%;
       z-index: -1;
       animation: gradientMove 5s ease infinite;
       opacity: 0;
       transition: opacity 0.6s ease;
     }
     
     &:hover{
       transform: translateY(-15px) rotateY(5deg) scale(1.05);
       filter: grayscale(0) brightness(1.1);
       box-shadow: 0 35px 90px rgba(99, 102, 241, 0.5),
                   0 15px 35px rgba(139, 92, 246, 0.4),
                   0 0 50px rgba(99, 102, 241, 0.3);
       border-color: rgba(99, 102, 241, 0.6);
       
       &::before {
         opacity: 1;
       }
     }
   }
  }
  
  @keyframes gradientMove {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }

  @media only screen and (max-width: 480px) {
    .about-image {
      // flex: 1;
      // max-width: 100%;
      // max-width: 20%;
      margin-top: 4rem;
      img{
        margin-top: 2rem;
        // width: 100%;
        width: 100%;
        // height: 200px;
        filter: grayscale(0);
        transition: filter 0.5s;
        &:hover{
          filter: grayscale(0);
        }
    }
  }

  @media (max-width: 960px){
    gap: 2rem;
    
    .hard-skills{
      grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
      gap: 1.5rem;
    }
    
    .hability {
      padding: 1.5rem;
      
      img {
        width: 4rem;
        height: 4rem;
      }
    }
  }

  @media (max-width: 480px){
    display: block;
    text-align: center;
    margin-top: 8rem;

    .hard-skills{
      grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
      gap: 1.2rem;
      justify-content: center;
    }
    
    .hability {
      padding: 1.2rem;
      
      img {
        width: 3.5rem;
        height: 3.5rem;
      }
    }
    
    h2::after {
      left: 50%;
      transform: translateX(-50%);
    }
    // .about-image{
    //   display: flex;
    //   // max-width: 100%;
    //   max-width: 1%;
    //   img{
    //     margin-top: 2rem;
    //     // width: 100%;
    //     width: 1%;
    //     filter: grayscale(0);
    //     transition: filter 0.5s;
    //     &:hover{
    //       filter: grayscale(0);
    //     }
    // }


    }

  @media (max-width: 768px) {
    flex-direction: column;
  }

`;
